import moment from 'moment';

export interface DateConstraints {
    selectableMinDate: Date;
    selectableMaxDate: Date;
    visibleMinDate: Date;
    visibleMaxDate: Date;
}

export const calculateCampaignDateConstraints = (
    modelStartDate: string,
    modelEndDate: string,
    userMinDate?: Date | null,
    userMaxDate?: Date | null,
): DateConstraints => {
    const modelStart = moment(modelStartDate, 'DD-MM-YYYY');
    const modelEnd = moment(modelEndDate, 'DD-MM-YYYY');

    const baseSelectableMinDate = modelEnd.toDate();
    const baseSelectableMaxDate = modelEnd.clone().add(3, 'years').toDate();

    const selectableMinDate = userMinDate
        ? moment.max(moment(userMinDate).startOf('day'), modelEnd).toDate()
        : baseSelectableMinDate;

    const selectableMaxDate = userMaxDate
        ? moment
              .min(
                  moment(userMaxDate).startOf('day'),
                  modelEnd.clone().add(3, 'years'),
              )
              .toDate()
        : baseSelectableMaxDate;

    const visibleMinDate = modelEnd.clone().startOf('year').toDate();

    const visibleMaxDate = modelEnd
        .clone()
        .add(3, 'years')
        .endOf('year')
        .startOf('day')
        .toDate();

    return {
        selectableMinDate,
        selectableMaxDate,
        visibleMinDate,
        visibleMaxDate,
    };
};

export const formatDateConstraints = (
    constraints: DateConstraints,
): {
    selectableMinDate: string;
    selectableMaxDate: string;
    visibleMinDate: string;
    visibleMaxDate: string;
} => {
    return {
        selectableMinDate: moment(constraints.selectableMinDate).format(
            'DD-MM-YYYY',
        ),
        selectableMaxDate: moment(constraints.selectableMaxDate).format(
            'DD-MM-YYYY',
        ),
        visibleMinDate: moment(constraints.visibleMinDate).format('DD-MM-YYYY'),
        visibleMaxDate: moment(constraints.visibleMaxDate).format('DD-MM-YYYY'),
    };
};
